let timeout: NodeJS.Timeout;

const aplDebounce = (fn: () => void, delay: number, immediate: boolean) => {
    clearTimeout(timeout);
    if (immediate) {
        fn();
    }
    else {
        timeout = setTimeout(() => {
            fn();
        }, delay);
    }
}

const onlyOnEnter = (e: React.KeyboardEvent<HTMLInputElement>, fn: () => void) => {
  if (e.keyCode === 13 && e.shiftKey === false) {
    e.preventDefault();
    fn();
  }
};

export { aplDebounce, onlyOnEnter }